import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  perfis: [],
};

const getters = {
  // Perfis
  perfis: state => state.perfis.sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
  perfisAtivo: state => state.perfis.filter(p => p.Status.startsWith('A')).sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
}

const actions = {
  // Perfis
  async fetchPerfis({ commit }) {
    const response = await axios.get(`${baseUrl}/perfis?resumido=true`);
    if (response.data) {
      commit('setPerfis', response.data);
    } else {
      commit('setPerfis', []);
    }
  },
  async fetchPerfisSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/perfis?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setPerfis', response.data);
      } else {
        commit('setPerfis', []);
      }
    } catch (error) {
      commit('setPerfis', []);
    }
  },
  async addPerfil({ commit }, perfil) {
    const response = await axios.post(`${baseUrl}/perfis`, perfil, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    perfil.IdPerfil = response.data.IdPerfil;
    commit('newPerfil', perfil);
    return response.data.IdPerfil;
  },
  async updatePerfil({ commit }, updPerfil) {
    await axios.put(`${baseUrl}/perfis`, updPerfil, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updatePerfil', updPerfil);
  },
  async deletePerfil({ commit }, id) {
    await axios.delete(`${baseUrl}/perfis/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removePerfil', id);
  },
}

const mutations = {
  // Perfil
  setPerfis: (state, perfis) => state.perfis = perfis,
  newPerfil: (state, perfil) => state.perfis.push(perfil),
  removePerfil: (state, id) => state.perfis = state.perfis.filter(perfil => perfil.IdPerfil !== id),
  updatePerfil: (state, updPerfil) => {
    const index = state.perfis.findIndex(perfil => perfil.IdPerfil === updPerfil.IdPerfil);
    if (index !== -1) {
      state.perfis.splice(index, 1, updPerfil);
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}